<section mat-dialog-title>
  <span>Remove authenticator app?</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content>
  <p class="mb-4">Enter the 6-digit code from your authenticator app to remove it. If your organization requires two-factor authentication, you'll receive a code by email each time you sign in instead.</p>
  <avs-totp-code
    (valueChange)="onTokenChange($event)"
    [invalid]="!!store.error()"
  />
  @if (store.error()) {
    <p class="mt-1 text-ui-red-50">{{ store.error() }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    class="btn-transparent btn-medium font-bold mr-4"
    mat-dialog-close
  >
    CANCEL
  </button>
  <button
    class="btn-green btn-medium font-bold"
    (click)="removeApp()"
    [disabled]="!isCodeComplete() || store.isPending()"
  >
    @if (store.isPending()) {
      <mat-spinner
        class="mr-1"
        diameter="20"
      ></mat-spinner>
    }
    REMOVE
  </button>
</mat-dialog-actions>
